type BodyContentProps = {
    children?: React.ReactNode
}

const BodyContentHeader = ({ children } : BodyContentProps) => (
    <>{children}</>
)

export default BodyContentHeader